module.exports = __webpack_public_path__ + "img/canada-tuberculosis-male.da809921.png";